import { useNotify } from "ra-core";
import { useState } from "react";

import { missionName, type CallMission } from "./callPlan";
import { recordResult, releaseCall, type QuickResult } from "./useCallPlan";

const RESULT_TOAST: Partial<Record<QuickResult, string>> = {
  no_answer: "no contesta (+1). Mañana vuelve a tu bolsa",
  contacted: "hablado (+3). Si hay recontacto o venta, apúntalo en su ficha",
};

/** One-click results and "give back" for the calls in a list. */
export const useMissionActions = (onChanged: () => void) => {
  const notify = useNotify();
  const [busyId, setBusyId] = useState<string | null>(null);

  const run = async (mission: CallMission, action: () => Promise<void>) => {
    setBusyId(String(mission.id));
    try {
      await action();
      onChanged();
    } catch (error) {
      notify(error instanceof Error ? error.message : "No se ha podido", {
        type: "error",
      });
    } finally {
      setBusyId(null);
    }
  };

  const handleResult = (mission: CallMission, result: QuickResult) =>
    run(mission, async () => {
      await recordResult(mission.client_id, result);
      const toast = RESULT_TOAST[result];
      if (toast) {
        notify(`${missionName(mission)}: ${toast}`, { type: "success" });
      }
    });

  const handleRelease = (mission: CallMission) =>
    run(mission, () => releaseCall(mission.id));

  return { busyId, handleResult, handleRelease };
};
